import createFocusTrap from 'focus-trap';
import { isFunction } from 'client/javascript/util/utils';
import { createElement, div } from './util/dom_utils';

class Overlay {
  constructor(id, opts = {}) {
    this.id = id;
    this.node = this._generateOverlayNode(opts);
    this.focusTrap = createFocusTrap(this.node, opts.focusTrap);

    this._addOverlayToDOM();
  }

  _addOverlayToDOM() {
    if (!this.node) {
      throw new Error('Overlay - Invalid overlay node.');
    }

    document.body.appendChild(this.node);
  }

  _generateCloseContainer() {
    const closeSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><g><path d="M18.8535,17.1465a.5.5,0,0,1-.707.707L12.5,12.207,6.8535,17.8535a.5.5,0,0,1-.707-.707L11.793,11.5,6.1465,5.8535a.5.5,0,1,1,.707-.707L12.5,10.793l5.6465-5.6465a.5.5,0,1,1,.707.707L13.207,11.5Z" /></g></svg>';
    const closeBtn = createElement('button', {
      className: 'close overlay-close-btn',
      html: closeSvg,
      events: { click: this.close }
    });
    const closeContainer = div({ className: 'close-container' }, [closeBtn]);

    return closeContainer;
  }

  _generateOverlayNode(opts) {
    const contentContainer = div({ className: 'overlay__content' });
    const children = [contentContainer];
    const includeCloseButton = !opts.excludeCloseButton;

    if (includeCloseButton) {
      const closeContainer = this._generateCloseContainer();

      children.unshift(closeContainer);
    }

    const overlayContainer = div(
      {
        className: `segmentation-overlay overlay overlay--no-transition overlay-${this.id}`,
        id: this.id,
        attrs: { 'aria-hidden': 'true' }
      },
      children
    );

    return overlayContainer;
  }

  _handleEscapeClose = evt => {
    const isEscapeKeyDown = evt.key === 'Escape';
    if (isEscapeKeyDown) {
      this.close();
    }
  };

  addContent(contentNode) {
    const contentContainer = this.node.querySelector('.overlay__content');
    contentContainer.appendChild(contentNode);
  }

  close = onClose => {
    const { body } = document;
    body.classList.remove('js-lock-scroll');
    document.removeEventListener('keydown', this._handleEscapeClose);
    this.node.classList.remove('open');
    this.node.setAttribute('aria-hidden', 'true');

    if (isFunction(onClose)) {
      onClose();
    }

    this.focusTrap.deactivate();
  };

  open = (evt, onOpen) => {
    if (evt) {
      evt.preventDefault();
    }

    const { body } = document;
    body.classList.add('js-lock-scroll');
    document.addEventListener('keydown', this._handleEscapeClose);
    this.node.classList.add('open');
    this.node.setAttribute('aria-hidden', 'false');

    if (isFunction(onOpen)) {
      onOpen();
    }

    this.focusTrap.activate();
  };
}

export default Overlay;
